import { useEffect, useRef } from "react";
import { useRouter } from "next/router";
import { trackUserPageView } from "@/services/api/notifications";

function buildRouteKey(router) {
  return `${router.pathname}|${JSON.stringify(router.query)}`;
}

/**
 * Sends UserTrackingApi on each page view / client navigation.
 */
export default function UserPageTracking() {
  const router = useRouter();
  const lastKeyRef = useRef("");

  useEffect(() => {
    if (!router.isReady) return undefined;

    const sendTracking = async () => {
      const key = buildRouteKey(router);
      if (!key || key === lastKeyRef.current) return;

      try {
        await trackUserPageView(router);
        lastKeyRef.current = key;
      } catch (error) {
        console.warn("[UserTracking] Page tracking failed:", error);
      }
    };

    sendTracking();

    const onRouteChangeComplete = () => {
      window.setTimeout(() => {
        sendTracking();
      }, 0);
    };

    router.events.on("routeChangeComplete", onRouteChangeComplete);

    return () => {
      router.events.off("routeChangeComplete", onRouteChangeComplete);
    };
  }, [router, router.isReady, router.pathname, router.query]);

  return null;
}
